import { Component } from '@angular/core';
import { AuthPageLayoutComponent } from '../../../layout/auth-page-layout/auth-page-layout.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-merchant-register-step',
  imports: [ AuthPageLayoutComponent, RouterModule, CommonModule ],
  templateUrl: './merchant-register-step.html',
  styleUrl: './merchant-register-step.css',
})
export class MerchantRegisterStep {

}
